/* eslint-disable no-unused-vars */

/**
 * Radio Lists
 */

$.expr[':'].contains = $.expr.createPseudo(function (arg) {
  return function (elem) {
    return $(elem).text().toUpperCase().indexOf(arg.toUpperCase()) >= 0;
  };
});

$('.js-radio-list-textbox').on('keyup', function (event) {
  var options = $(this).closest('.radio-list').find('.radio-list__option');

  options.attr('hidden', 'hidden');
  var value = $(this).val();

  options
    .filter(`:contains(${value})`)
    .closest('.radio-list__option')
    .removeAttr('hidden');

  $('.js-clear-radio').show();

  if (value == '') {
    $('.js-clear-radio').hide();
  }
  return false;
});

$('.js-clear-radio').on('click', function () {
  $(this).parent().find('.js-radio-list-textbox').val('');
  $('.js-radio-list-textbox').trigger('keyup');
  return false;
});

$('.js-radio-dirty-trigger').click(function () {
  console.log('ISAddressFormDirty value: ' + $('#isAddressFormDirty').val());
  $('#isAddressFormDirty').val($(this).attr('id'));
});

// show address book/new address options
$('.js-address-change').click(function (e) {
  $('#existing-address').trigger('click');
  $('.js-hidden-option').removeClass('hidden');
  $('#LastAddressId').val('');
  return false;
});

const addressFormChoice = $('#isAddressFormDirty').val();
const isPostCodeError = $('#isPostcodeError').val();

if (addressFormChoice !== '' || isPostCodeError) {
  if (addressFormChoice !== 'last-used-address') {
    $('.js-hidden-option').removeClass('hidden');
  }
  $(`#${addressFormChoice}`).trigger('click');
}
